import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app-config';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ISearchArticleRequest } from '../../../core/models/i-search-article-request';
import {
  ISearchContentResponse,
  SearchContentResponse,
} from '../../../core/models/i-search-content-response';
import { RestService } from 'src/app/shared/services/rest-service';
import { IParseArticleUrlResponse } from 'src/app/core/models/i-parse-article-url-response';
import { VERSION_HEADER } from 'src/app/core/constants/version-header';

@Injectable({
  providedIn: 'root',
})
export class ContentService {
  static readonly ENTITY_IDENTIFIER: string = 'content';
  private readonly BASE_CONTENT_ROUTE = `api/${ContentService.ENTITY_IDENTIFIER}`;
  contentResultLimit: number;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_CONTENT_ROUTE, ...args);

  constructor(private restService: RestService, private appConfig: AppConfig) {
    this.contentResultLimit = this.appConfig.contentResultLimit;
  }

  getFiltered$(
    request: ISearchArticleRequest
  ): Observable<ISearchContentResponse> {
    let headers = new HttpHeaders();
    headers = headers.append(VERSION_HEADER, '3.0');

    return this.restService.post$<ISearchContentResponse>(
      this.BUILD_HTTP_ROUTE('search'),
      request,
      { headers }
    );
  }

  getByUrl$(url: string): Observable<IParseArticleUrlResponse> {
    const params = this.restService.buildHttpParamsObject({
      url: url,
    });

    return this.restService.get$<IParseArticleUrlResponse>(
      this.BUILD_HTTP_ROUTE('url'),
      { params }
    );
  }
}
